import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AltaSolicitudesService, OptionsService, ContribuyentesService, MantenimientoContribuyentesService, ReportesPDFService } from '../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import swal2 from 'sweetalert2';
import { Facturas } from 'src/app/models/usuario.model';
import { forkJoin, Observable } from 'rxjs';
// [13/08/2026] Se retiró Bugsnag: el dashboard no se revisaba hace ~1 año.
import { ILabelsAltaSolicitudes, LABELS_ALTA_SOLICITUDES, IdiomaDisponible } from '../../i18n/alta-solicitudes-labels';

declare var $;

@Component({
  selector: 'app-altasolicitudes',
  templateUrl: './altasolicitudes.component.html',
  styleUrls: ['./altasolicitudes.component.css']
})
export class AltaSolicitudesComponent implements OnInit {
  // interest_mode = '';
  @ViewChild('dt', { static: false }) tabla: Table;
  @HostListener('window:resize', ['$event'])
  onResize(event)
  {
    this.esmovil(event.target.innerWidth);
    
  }
  filasPorPagina: number = 100;
  opcionesTamanoPagina: number[] = [20, 50, 100];
  paginaActualSeleccionada: boolean = false;
  paginaActualIndeterminada: boolean = false;
  // INICIO CAMBIO: checkbox "Todas" externo
  todasSeleccionadas: boolean = false;
  // FIN CAMBIO
  mobile = false;
  isActive = true;
  showModal: boolean;
  cols: any[];
  horalimite: boolean;
  poperacion: number;
  selectedFactsCf: any[] = [];
  selectedFactsSf: any[] = [];
  selectedFac: Facturas[];
  options: any[] = [];
  facturas: any[] = [];
  facturass: any[] = [];
  facturasfiltradas: any[] = [];
  simulacion: any[];
  idu: string;
  cadenaproveedor: any[];
  nombrecadena: string[];
  nombreproveedor: string[];
  companyid: string;
  supplierid: string;
  supplieridbandera: boolean;
  invoices: any[] = [];
  load: boolean;
  firmantes: any[] = [];
  confirma = true;
  muestratabla = true;
  muestratablafirmantes = false;
  currency: any[] = [];
  vienesinfiltro = false;
  totalaoperar;
  totalaoperearfiltro;
  proyectos: any[] = [];
  fechaHoy: string;
  fechaHoyParametro: string;
  muestracalendar: boolean;
  invoicesrequest: any[] = [];
  invoicesrequestrel: any[] = [];
  datostablapopup = [];
  unselectable = false;
  habilitasimulacion = true;
  // PARA REPORTE
  facturasReporte = [];
  respuesta: any[];
  uploadURL: Observable<string>;
  direcciones: any[];
  contribuyentes: any[];
  idcontsuplier = '';
  idcontcomany = '';
  startdatesuplier = '';
  direccioncompany = '';
  firmantesreporte: any[];
  firmantesreportenombres = '';
  cesionDerechosMode = '';
  admin = false;
  cadenas = [];
  companies = [];
  proveedores = [];
  fo;
  mon;
  detallado = true;
  multi_cadena = false;
  labels: ILabelsAltaSolicitudes;

  constructor(private _formBuilder: FormBuilder,
              public router: Router,
              private route: ActivatedRoute,
              public _optionsservice: OptionsService,
              public _contribuyentesService: ContribuyentesService,
              public reportespdf: ReportesPDFService,
              public _mantenimientocontservice: MantenimientoContribuyentesService,
              public _solicitudesservice: AltaSolicitudesService) {}

  ngOnInit() {
    // Determinación de idioma con fallback a español - 27/06/2025
    try {
      const foreign = localStorage.getItem('foreign');
      const idioma: IdiomaDisponible = (foreign === 'true') ? 'en' : 'es';
      this.labels = LABELS_ALTA_SOLICITUDES[idioma];
    } catch (e) {
      this.labels = LABELS_ALTA_SOLICITUDES['es'];
    }

    swal2.fire({
      title: this.labels.swalCargandoInfo,
      allowOutsideClick: false
    });
    swal2.showLoading();
    //inicializacion
    this.multi_cadena = false;
    const checkele = document.getElementById("flexCheckDefault") as HTMLInputElement;
    checkele.checked = false;
    this.nombreproveedor = [];
    this.cadenas = [];
    this.proveedores = [];
    this.selectedFactsSf = [];
    this.facturas = [];
    this.esmovil(window.innerWidth);
    this.admin = false;
    this.isActive = true;
    this.unselectable = false;
    this.habilitasimulacion = true;
    // SE COMENTA POR QUE EL PARAMETRO INTEREST_MODE YA NO SE USA Y EL BACK DABA UN 500 CADA QUE PASABA POR AQUI.
    // this._solicitudesservice.getGeneralParam('INTEREST_MODE').subscribe(param => {
    //   this.interest_mode = param['value'];
    // });
    setTimeout(() => {
      this._solicitudesservice.getGeneralParam('DETAILS_REQUEST_MODE').subscribe(r =>{
      if (r.hasOwnProperty('value') && r['value'] !== null) {
        if (r['value'].toUpperCase() === 'DETALLADO') {
          this.detallado = true;
        } else if (r['value'].toUpperCase() === 'GENERAL') {
          this.detallado = false;
        } else {
          this.detallado = true;
        }
        } else {
          this.detallado = true;
        }
    });
    }, 2000);



    // consultar parametro general para el servicio de factoraje
    this._solicitudesservice.getGeneralParam('SOLICITUDES_FUERA_SERVICIO').subscribe(param => {
      if(param.hasOwnProperty('value') && param['value'] === 'SI'){
        swal2.fire({
          text: this.labels.swalServicioNoDisponible,
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
          }). then ( res => {
            if ( res.value ) {
              this.router.navigate(['/dashboard']);
            }
          } );
      }else{
        // si factoraje esta en servicio inicializamos       
        this.cols = [
          { field: 'invoice_folio', header: this.labels.numeroDeFactura },
          { field: 'uuid', header: this.labels.uuid },
          { field: 'status', header: this.labels.estatus },
          { field: 'invoice_date', header: this.labels.fechaFactura },
          { field: 'due_date', header: this.labels.fechaDeVencimiento },
          { field: 'totalformateado', header: this.labels.total },
        ];
        this.horalimite = false;
        this.idcontsuplier = '';
        this.idcontcomany = '';
        this.totalaoperar = 0;
        this.totalaoperearfiltro = 0;
        this.poperacion = 100;
        this.confirma = true;
        let valormoneda;
        this. firmantesreporte = [];
        this.vienesinfiltro = false;
        this.muestratabla = true;
        this.muestratablafirmantes = false;
        this.selectedFactsCf = [];
        this.selectedFactsSf = [];
        //(document.getElementById('fechafactura') as HTMLInputElement).value = '';
        this.simulacion = [];
        this.idu = localStorage.getItem('id');
        if (localStorage.getItem('multi_supplier') === 'true') {
          this.multi_cadena = true;
        }
        /* se unen los 3 endpoints necesarios en un forkjoin porque ninguno de los 3 puede fallar
           para la operacion del alta*/
        const observable1 = this._solicitudesservice.getPaymentCurrency();
        const observable2 = this._solicitudesservice.getFechaParametro();
        const observable3 = this._solicitudesservice.getCadenaProveedor(this.idu);
        forkJoin([observable1, observable2, observable3]).subscribe(async ([res1, res2, res3]) => {
          this.currency = res1;
          valormoneda = await this.obtenerMoneda();
          // validamos si existe un error al obtener la moneda ya que si lo hay no podemos continuar
          if (valormoneda === 'Error') {
            swal2.fire({
              title: this.labels.swalErrorConsultarMoneda,
              icon: 'info',
              allowOutsideClick: false
            }). then ( res => {
              if ( res.value ) {
                this.router.navigate(['/dashboard']);
              }
            } );
            return
          }
          //bloque 2 para la Fecha de operación
          this.fechaHoyParametro = res2;
            if (this.fechaHoyParametro === 'calendar') {
                this.muestracalendar = true;
                const a = new Date();
                a.setMinutes( a.getMinutes() + a.getTimezoneOffset() );
                let montha = '' + (a.getMonth() + 1);
                let daya = '' + a.getDate();
                const yeara = a.getFullYear();
                if (montha.length < 2) {
                montha = '0' + montha;
              }
                if (daya.length < 2) {
                daya = '0' + daya;
              }
                this.fechaHoy = [yeara, montha, daya].join('-');
              } else if (this.fechaHoyParametro.includes('Hora')){
                this.horalimite = true;
              } else {
                const a = new Date();
                a.setMinutes( a.getMinutes() + a.getTimezoneOffset() );
                let montha = '' + (a.getMonth() + 1);
                let daya = '' + a.getDate();
                const yeara = a.getFullYear();
                if (montha.length < 2) {
                montha = '0' + montha;
              }
                if (daya.length < 2) {
                daya = '0' + daya;
              }
                this.fechaHoy = [yeara, montha, daya].join('-');
                this.muestracalendar = false;
                }
          // bloque 3 para las companies y determinar si es admin o no
          this.companies = res3;
                  if (res3.length == 1) {
                    this.cadenaproveedor = res3;
                    this.nombrecadena = this.cadenaproveedor[0].cadena;
                    this.nombreproveedor = this.cadenaproveedor[0].proveedor;
                    this.companyid = this.cadenaproveedor[0].company_id;
                    this.supplierid = this.cadenaproveedor[0].supplier_id;
                    this.admin = false;
                    this.procesoFacturas(valormoneda, this.supplierid);
                } else if (res3.length > 1 && this.multi_cadena){
                  this.admin = false;
                  this.cadenaproveedor = res3;
                  this.companyid = this.cadenaproveedor[0].company_id;
                  this.nombrecadena = this.cadenaproveedor[0].cadena;
                  this.proveedores = res3;
                  swal2.close();
                } else if (res3.length > 1 && !this.multi_cadena){
                  this.admin = true;
                  this.cadenas = res3.filter(c => c.tipo == 'CADENA');
                  swal2.close();
                } else {
                  swal2.close();
                    swal2.fire({
                      title: this.labels.swalNoFacturasPendientes,
                      icon: 'info',
                      allowOutsideClick: false
                    }). then ( res => {
                      if ( res.value ) {
                        this.router.navigate(['/dashboard']);
                      }
                    } );
                }
              }, (err) => {
                console.log(err);
                swal2.close();
                swal2.fire({
                  title: this.labels.swalErrorConsultarInfo,
                  icon: 'info',
                  allowOutsideClick: false
                }). then ( res => {
                  if ( res.value ) {
                    this.router.navigate(['/dashboard']);
                  }
                } );
        }); 
    }
    
    })

  }

formatNumber(value: any): string {
  if (value === null || value === undefined) return '';
  let str = String(value);
  let [entera, decimal = ''] = str.split('.');
  decimal = decimal.substring(0, 2).padEnd(2, '0');
  let enteraNum = Number(entera.replace(/,/g, ''));
  if (isNaN(enteraNum)) return value;
  let enteraFormateada = enteraNum.toLocaleString('en-US');
  return `${enteraFormateada}.${decimal}`;
}
  
  isRowSelected(row: any): boolean {
    return Array.isArray(this.selectedFactsSf) && this.selectedFactsSf.includes(row);
  }

  async obtenerMoneda() {
    /* se hace una promesa para resolver cuando se tengan datos en el arreglo y
    asignar la moneda que esta a la vista del usuario*/
    return new Promise(resolve => {
      let res: string;
      setTimeout(() => {
        try {
          res = ((document.getElementById('moneda') as HTMLInputElement).value);
        } catch (error) {
          res = 'Error'
        }
        resolve(res);
      }, 100);
    });
  }

  esmovil(wid) {
    if(wid < 640) {
      this.mobile = true;
    } else {
    this.mobile = false;
    }
  }
  refresca() {
    window.location.reload();
  }

  procesoFacturas(valormoneda, supplierid){
    this.facturas = [];
    this.supplierid = supplierid;
    this._solicitudesservice.getFacturas(this.companyid, this.supplierid, valormoneda).subscribe( resp2 => {
      this.facturas = resp2;
      // tslint:disable-next-line: forin
      for (const prop in this.facturas) {
        if (this.facturas[prop].capacity != null && this.facturas[prop].capacity != '' && this.facturas[prop].capacity <= 99.9) {
        this.unselectable = true;
        this.habilitasimulacion = true;
        this.facturas[prop].porcentaje = parseFloat(this.facturas[prop].capacity);
        this.facturas[prop].totalaoperar = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        this.facturas[prop].totalformateado = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        } else {
        this.unselectable = false;
        this.habilitasimulacion = false;
        this.facturas[prop].porcentaje = 100;
        this.facturas[prop].totalaoperar = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        this.facturas[prop].totalformateado = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
      }
    } );
                                                                          
  if (String(this.supplierid) !== '0') {
    
    this.supplieridbandera = false;
    this._solicitudesservice.getSignatories(this.supplierid).subscribe(resp2 => { this.firmantes = resp2;
      // tslint:disable-next-line: forin
      for (const prop in this.firmantes) {
        this.firmantesreporte[prop] = this.firmantes[prop].firmante;
      }
      this.firmantesreportenombres = this.firmantesreporte.join(' / ');
    });
  } else {
    
    this.supplieridbandera = true;
    this._solicitudesservice.getSignatoriesw(this.companyid).subscribe(resp2 => { this.firmantes = resp2;// console.log(this.firmantes)
      // tslint:disable-next-line: forin
      for (const prop in this.firmantes) {
        this.firmantesreporte[prop] = this.firmantes[prop].firmante;
      }
      this.firmantesreportenombres = this.firmantesreporte.join(' / ');
    });
  }
  swal2.close();
  }

  seleccionarCadena(){
    this.facturas = [];
    this.nombrecadena = [];
    this.nombreproveedor = [];
    this.selectedFactsSf = [];
    this.selectedFactsCf = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.muestratabla = true;
    //(document.getElementById('fechafactura') as HTMLInputElement).value = '';
    let seleccion = (document.getElementById('cadenaSel') as HTMLInputElement).value;
    if(seleccion != 'invalido'){
      this.companyid = seleccion;
      try {
        this.nombrecadena = (this.cadenas.filter(p =>  p.company_id == seleccion)[0].cadena);
      } catch (error) {
        console.log(error);
      }   
      //this.supplierid = '0';
      this.proveedores = this.companies.filter(p => p.tipo == 'PROVEEDOR' && p.company_id == seleccion);
      if(this.proveedores.length == 0){
      let moneda = (document.getElementById('moneda') as HTMLInputElement).value;
      let supplierid = this.companies.find(s => s.company_id == seleccion).supplier_id;
        this.procesoFacturas(moneda, supplierid);
      }
    }else{
      swal2.fire({
        text: this.labels.swalSeleccioneCadena,
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            window.location.reload();
          }
        } );
    }
  }
  seleccionarProveedor(){
    this.selectedFactsSf = [];
    this.selectedFactsCf = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.muestratabla = true;
    //(document.getElementById('fechafactura') as HTMLInputElement).value = '';
    let supplierid = (document.getElementById('proveedorSel') as HTMLInputElement).value;
    try {
      this.nombreproveedor = (this.proveedores.filter(p =>  p.supplier_id == supplierid)[0].proveedor);
    } catch (error) {
      console.log(error);
    } 
    let moneda = (document.getElementById('moneda') as HTMLInputElement).value;
    this.procesoFacturas(moneda, supplierid);

  }
  show() {
    this.showModal = true; // Show-Hide Modal Check
  }
  hide() {
    this.showModal = false;
  }

    actualizatosinfiltro() {
    if (this.selectedFactsSf.length === 0) {
      swal2.fire(this.labels.swalSeleccioneFactura, '', 'info');
      this.totalaoperar = 0;
      this.habilitasimulacion = true;
    } else {
      this.totalaoperar = 0;
      // tslint:disable-next-line: forin
      for (const prop in this.selectedFactsSf) {
        this.selectedFactsSf[prop].totalaoperar = this.selectedFactsSf[prop].total * (this.selectedFactsSf[prop].porcentaje / 100);
        this.totalaoperar = this.totalaoperar + (this.selectedFactsSf[prop].totalaoperar);
        this.selectedFactsSf[prop].totalaoperar = parseFloat(this.selectedFactsSf[prop].totalaoperar.toString()).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      this.totalaoperar = (this.totalaoperar).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      this.habilitasimulacion = false;
    }
  }

    muestraxcurr() {
    this.selectedFactsSf = [];
    this.selectedFactsCf = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.muestratabla = true;
    //(document.getElementById('fechafactura') as HTMLInputElement).value = '';
    const moneda: any = document.getElementById('moneda');
    const valormoneda = moneda.options[moneda.selectedIndex].value;
    if(this.cadenas.length == 0){
      this._solicitudesservice.getCadenaProveedor(this.idu).subscribe( resp => {
        this.cadenaproveedor = resp;
        this.nombrecadena = this.cadenaproveedor[0].cadena;
        this.nombreproveedor = this.cadenaproveedor[0].proveedor;
        this.companyid = this.cadenaproveedor[0].company_id;
        this.supplierid = this.cadenaproveedor[0].supplier_id;
        this._solicitudesservice.getFacturas(this.companyid, this.supplierid, valormoneda).subscribe( resp2 => {
          this.facturas = resp2;
          
          for (const prop in this.facturas) {
            if (this.facturas[prop].capacity != null && this.facturas[prop].capacity != '' && this.facturas[prop].capacity <= 99.9) {
              this.unselectable = true;
              this.habilitasimulacion = true;
              this.facturas[prop].porcentaje = parseFloat(this.facturas[prop].capacity);
              this.facturas[prop].totalaoperar = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              this.facturas[prop].totalformateado = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              } else {
                this.unselectable = false;
                this.habilitasimulacion = false;
                this.facturas[prop].porcentaje = 100;
                this.facturas[prop].totalaoperar = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                this.facturas[prop].totalformateado = parseFloat(this.facturas[prop].total).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            
          }
        } );

      } );
    }else if(this.cadenas.length > 0){
      var supplierid;
      let moneda = (document.getElementById('moneda') as HTMLInputElement).value;
      if(this.proveedores.length == 0){
        let seleccion = (document.getElementById('cadenaSel') as HTMLInputElement).value;
        supplierid = this.companies.find(s => s.company_id == seleccion).supplier_id;
        // this.procesoFacturas(moneda, supplierid);
      }else{
        supplierid = (document.getElementById('proveedorSel') as HTMLInputElement).value;
      }
      this.procesoFacturas(moneda, supplierid);
    }

  }

  creaSolicitud() {

      this.load = true;
      let total = 0 ;
      this.invoices = [];
      let fechaMayorFactura = '';
      let fechaMayorDueDate = '';
      const moneda: any = document.getElementById('moneda');
      const valormoneda = moneda.options[moneda.selectedIndex].value;
      // tslint:disable-next-line: forin
      for ( const prop in this.selectedFactsSf ) {
        total = total + parseFloat( this.selectedFactsSf[prop].total );
        this.invoices.push(this.selectedFactsSf[prop].id);
        }

      fechaMayorFactura = this.selectedFactsSf[0].invoice_date;
      for (const prop in this.selectedFactsSf) {
          if (fechaMayorFactura < this.selectedFactsSf[prop].invoice_date) {
           fechaMayorFactura = this.selectedFactsSf[prop].invoice_date;
          }
        }

      const fechafactura = fechaMayorFactura;

      const a = new Date((document.getElementById('fechaoperacion')as HTMLInputElement).value);
      a.setMinutes( a.getMinutes() + a.getTimezoneOffset() );
      let montha = '' + (a.getMonth() + 1);
      let daya = '' + a.getDate();
      const yeara = a.getFullYear();

      if (montha.length < 2) {
          montha = '0' + montha;
      }
      if (daya.length < 2) {
          daya = '0' + daya;
      }

      const fechaoperacion = [yeara, montha, daya].join('-');

      fechaMayorDueDate = this.selectedFactsSf[0].due_date;
      for (const prop in this.selectedFactsSf) {
      if (fechaMayorDueDate < this.selectedFactsSf[prop].due_date) {
        fechaMayorDueDate = this.selectedFactsSf[prop].due_date;
      }
    }

      const data = {
        invoices: [],
        request: {
                   company_id: this.companyid.toString(),
                   ...(this.supplieridbandera ? {} : { supplier_id: this.supplierid.toString() }),
                   user_id: this.idu,
                   total: total.toString(),
                   capacity: '100',
                   request_date: this.fechaHoy,
                   used_date: fechaoperacion,
                   due_date: fechaMayorDueDate,
                   currency: valormoneda,
                   status: 'PENDIENTE'
                 }
    };

      // tslint:disable-next-line: forin
      for (const prop in this.selectedFactsSf) {
        data.invoices[prop] = {id: this.selectedFactsSf[prop].id.toString(), percent: this.selectedFactsSf[prop].porcentaje };
      }
      swal2.fire({
        title: this.labels.swalCargando,
        allowOutsideClick: false
      });
  
    swal2.fire(this.labels.swalCreandoSolicitud,'','info')
      swal2.showLoading();
      this._solicitudesservice.confirmacion(data).subscribe(
       resp => {
                this.solicitudFirma(resp);

              }, (err) => {
                console.log(err);
                swal2.fire({
                  title: this.labels.swalErrorCrearSolicitud,
                  text: '',
                  icon: 'error',
                  showConfirmButton: true,
                  showCancelButton: false,
                  allowOutsideClick: false
                }). then ( res => {
                  if ( res.value ) {
                    this.load = false;
                    location.reload();
                  }
                } );
               }
      );
  }

  solicitudFirma(resp){
    swal2.fire({
      title: this.labels.swalSolicitudExitosa,
      text:  resp[0].folio,
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.load = false;
        window.location.reload();
    }
    })
  }

  enableconfirm() {
    this.confirma = !this.confirma;
  }

  recalculasinfiltro() {
    if (this.horalimite) {
        swal2.fire({
        title: this.labels.swalHoraLimite,
        text: this.fechaHoyParametro,
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
        }). then ( res => {
        if ( res.value ) {
        location.reload();
  }
} );
    }
    else {
    //si el supplier es difernete de 0
    if (this.selectedFactsSf.length === 0) {
      swal2.fire(
        this.labels.swalSeleccioneFactura,
        '',
        'error'
     );
    } else {
      swal2.fire({
        title: this.labels.swalCargando,
        allowOutsideClick: false
   });
    swal2.showLoading();
    let total = 0 ;
    let fechaMayorFactura = '';
    let fechaMayorDueDate = '';

    const moneda: any = document.getElementById('moneda');

    const valormoneda = moneda.options[moneda.selectedIndex].value;
    // tslint:disable-next-line: forin
    for ( const prop in this.selectedFactsSf ) {

    total = total + parseFloat( this.selectedFactsSf[prop].total );

    }
    // Fecha de operación request date
    fechaMayorFactura = this.selectedFactsSf[0].invoice_date;
    for (const prop in this.selectedFactsSf) {
      if (fechaMayorFactura < this.selectedFactsSf[prop].invoice_date) {
       fechaMayorFactura = this.selectedFactsSf[prop].invoice_date;
      }
    }

    const fechafactura = fechaMayorFactura;
  //  console.log(fechafactura);

    // Fecha Factura used date
    const a = new Date((document.getElementById('fechaoperacion')as HTMLInputElement).value);
    a.setMinutes( a.getMinutes() + a.getTimezoneOffset() );
    let montha = '' + (a.getMonth() + 1);
    let daya = '' + a.getDate();
    const yeara = a.getFullYear();

    if (montha.length < 2) {
        montha = '0' + montha;
    }
    if (daya.length < 2) {
        daya = '0' + daya;
    }

    const fechaoperacion = [yeara, montha, daya].join('-');

    fechaMayorDueDate = this.selectedFactsSf[0].due_date;
    for (const prop in this.selectedFactsSf) {
      if (fechaMayorDueDate < this.selectedFactsSf[prop].due_date) {
        fechaMayorDueDate = this.selectedFactsSf[prop].due_date;
      }
    }

    const paramssimul = {
      simulation: true,
      invoices: [],
      request: {
                 company_id: this.companyid.toString(),
                 ...(this.supplieridbandera ? {} : { supplier_id: this.supplierid.toString() }),
                 user_id: this.idu,
                 total: total.toString(),
                 capacity: '100.00',
                 request_date: this.fechaHoy,
                 used_date: fechaoperacion,
                 due_date: fechaMayorDueDate,
                 currency: valormoneda,
                 status: 'PENDIENTE'

               }
  };

  // tslint:disable-next-line: forin
    for (const prop in this.selectedFactsSf) {
      paramssimul.invoices[prop] = {id: this.selectedFactsSf[prop].id.toString(), percent: this.selectedFactsSf[prop].porcentaje };
  }
    this.vienesinfiltro = true;
    this.simulacion = [];
    this.datostablapopup = [];
    this.mon = (valormoneda)
    this.fo = (fechaoperacion);
    this._solicitudesservice.getSimulacion( paramssimul ).subscribe( resp => {
      this.isActive = false;
      swal2.close(); 
      let suma_fees = 0;
      for (const i in resp.data.relations.invoices) {
        this.invoicesrequest.push(resp.data.relations.invoices[i].attributes)
        for (const h in resp.data.relations.request_invoices) {
          if ( resp.data.relations.invoices[i].attributes.id === resp.data.relations.request_invoices[h].attributes.invoice_id ) {
            suma_fees = suma_fees + parseFloat(resp.data.relations.request_invoices[h].attributes.fee_total);
            var reg = { 
              folio: resp.data.relations.invoices[i].attributes.invoice_folio,
              uuid: resp.data.relations.invoices[i].attributes.uuid,
              ext_rate: resp.data.relations.request_invoices[h].attributes.ext_rate,
              int_rate: resp.data.relations.request_invoices[h].attributes.int_rate,
              total_rate: resp.data.relations.request_invoices[h].attributes.total_rate,
              interests: resp.data.relations.request_invoices[h].attributes.interests,
              total_used: resp.data.relations.request_invoices[h].attributes.total_used,
              discount_days: resp.data.relations.request_invoices[h].attributes.discount_days,
              rate: resp.data.relations.invoices[h].attributes.rate,
              total_fee: resp.data.relations.request_invoices[i].attributes.fee_total,
              financial_cost: resp.data.relations.request_invoices[i].attributes.financial_cost,
              fee: resp.data.relations.request_invoices[h].attributes.fee_rate,
              total_invoice: resp.data.relations.invoices[i].attributes.total,
              opening_commission: '0',
              net_amount: resp.data.relations.request_invoices[h].attributes.net_amount,
              total_rate_mod: Math.trunc((resp.data.relations.request_invoices[h].attributes.total_rate / 12)*100)/100,
              interes: resp.data.relations.request_invoices[h].attributes.interests,
              iva_del_interes: resp.data.relations.request_invoices[h].attributes.interest_iva,
              comision: resp.data.relations.request_invoices[h].attributes.fee_total,
              iva_de_la_comision: resp.data.relations.request_invoices[h].attributes.commission_iva
            }
            // SE COMENTA POR QUE EL PARAMETRO INTEREST_MODE YA NO SE USA Y EL BACK DABA UN 500 CADA QUE PASABA POR AQUI.
            // #evaluar si aun se va a usar esto del INTEREST_MODE
            // if(this.interest_mode == 'SEGMENT'){
            //   reg['int_rate'] = resp.data.relations.request_invoices[h].attributes.int_rate;
            // }else if(this.interest_mode == 'INDIVIDUAL'){
            //   reg['int_rate'] = resp.data.relations.invoices[h].attributes.rate;
            // }
            this.datostablapopup.push( reg )
          }
        }
      }
      this.simulacion.push(resp.data.attributes);
      const fecha1 = new Date(this.simulacion[0].used_date);
      const fecha2 = new Date(this.simulacion[0].due_date);
      const milisegundosdia = 24 * 60 * 60 * 1000;
      const milisegundostranscurridos = Math.abs(fecha1.getTime() - fecha2.getTime());
      const diastranscurridos = Math.round(milisegundostranscurridos / milisegundosdia);
      this.simulacion[0].diastranscurridos = diastranscurridos;
      this.muestratablafirmantes = true;
      const totalformat = parseFloat(this.simulacion[0].total.replace(/,/g, ''));
      this.simulacion[0].total = totalformat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const totalusedformat = parseFloat(this.simulacion[0].total_used.replace(/,/g, ''));
      this.simulacion[0].total_used = totalusedformat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const interestsformat = parseFloat(this.simulacion[0].interests.replace(/,/g, ''));
      this.simulacion[0].interests = interestsformat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fee_totalformat = suma_fees;
      this.simulacion[0].fee_total = fee_totalformat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const netamountformat = parseFloat(this.simulacion[0].net_amount.replace(/,/g, ''));
      this.simulacion[0].net_amount = netamountformat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const fee_format = parseFloat(this.simulacion[0].fee.replace(/,/g, ''));;
      this.simulacion[0].fee = fee_format.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const iva_interests_format = parseFloat(this.simulacion[0].iva_interests.replace(/,/g, ''));;
      this.simulacion[0].iva_interests = iva_interests_format.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const iva_fee_format = parseFloat(this.simulacion[0].iva_fee.replace(/,/g, ''));;
      this.simulacion[0].iva_fee = iva_fee_format.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      
    }, (err) => {
      swal2.close();
      console.log(err)
      swal2.fire({
        title: this.labels.swalOcurrioError,
        text: err.error.errors[0],
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }). then ( res => {
        if ( res.value ) {
          location.reload();
        }
      } );
      } );
  }

}
}

  obtenerFilasPaginaActual(): any[] {
    if (!this.tabla) {
      return [];
    }
    const inicio = this.tabla.first || 0;
    const fin = inicio + this.tabla.rows;
    const datos = this.tabla.filteredValue || this.facturas;
    return datos.slice(inicio, fin);
  }

  toggleSeleccionPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    const todasSeleccionadas = filasPagina.length > 0 && filasPagina.every(fila => this.selectedFactsSf.includes(fila));

    if (todasSeleccionadas) {
      this.selectedFactsSf = this.selectedFactsSf.filter(fila => !filasPagina.includes(fila));
    } else {
      const filasNuevas = filasPagina.filter(fila => !this.selectedFactsSf.includes(fila));
      this.selectedFactsSf = [...this.selectedFactsSf, ...filasNuevas];
    }

    this.actualizarEstadoCheckboxPagina();
  }

  actualizarEstadoCheckboxPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    if (filasPagina.length === 0) {
      this.paginaActualSeleccionada = false;
      this.paginaActualIndeterminada = false;
      return;
    }
    const seleccionadas = filasPagina.filter(fila => this.selectedFactsSf.includes(fila)).length;
    this.paginaActualSeleccionada = seleccionadas === filasPagina.length;
    this.paginaActualIndeterminada = seleccionadas > 0 && seleccionadas < filasPagina.length;
  }

  get excedeLimite(): boolean {
    return this.selectedFactsSf.length > 50;
  }

  // INICIO CAMBIO: checkbox "Todas" externo
  toggleSeleccionTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    if (this.todasSeleccionadas) {
      this.selectedFactsSf = [];
    } else {
      this.selectedFactsSf = [...datos];
    }
    this.todasSeleccionadas = !this.todasSeleccionadas;
    this.actualizarEstadoCheckboxPagina();
  }

  actualizarEstadoCheckboxTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    this.todasSeleccionadas = datos.length > 0 && this.selectedFactsSf.length === datos.length;
  }
  // FIN CAMBIO

}







